// extracted by mini-css-extract-plugin
export default {"frame-class":"_1Xb16X8GAxUNS0Vtg9cHMi"};